import { extractStringValueSet } from './extract-properties';

/**
 * Lists the deprecated types of order items
 * Add new deprecated types to ItemType in addition to here
 */
export default class DeprecatedItemType {

    static readonly GeneratePDFReport = 'generate-pdf-report';
    static readonly InfectiousDiseaseReport = 'infectious-disease-report';
    static readonly ReportAddendum: string = 'report-addendum';
    static readonly ReportAmendment: string = 'report-amendment';

    protected static readonly _valueSet: Set<string> = extractStringValueSet(DeprecatedItemType);

    static get values(): Set<string> {
        // Always return a new copy.
        return new Set<string>(DeprecatedItemType._valueSet);
    }
}
